import React from 'react';

import './style.sass';

const CommonSmallTitle = ({ children, className = '' }) => {
    return <h3 className={`common__small-title ${className}`}>{children}</h3>;
};

export default CommonSmallTitle;
